module.exports = __webpack_public_path__ + "img/icon8.a12484ce.png";